/**
 * This custom hook provides the functionality to save a user with the given parameters.
 */

import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {useContext} from "react";
import {FirebaseAuthContext} from "../../../firebase/FirebaseAuthProvider";
import {firebaseService} from "../../../firebase/Firebase";
import {useIntl} from "react-intl";

const useChangePassword = () => {
    const {signedInUser} = useContext(FirebaseAuthContext);
    const history = useHistory();
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    const changePassword = async (currentPassword, newPassword, newPasswordRepeat) => {
        const credentials = firebaseService.auth.EmailAuthProvider.credential(signedInUser.email, currentPassword)
        return firebaseService.auth().currentUser.reauthenticateWithCredential(credentials)
            .then(() => {
                return firebaseService.auth().currentUser.updatePassword(newPassword)
            })
            .then(() => {
                history.push('/common/profile');
                // Password change success
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.profile.messages.changePassword.success',
                        defaultMessage: 'Password successfully changed.'
                    }), {
                        variant: 'success',
                        preventDuplicate: true,
                        autoHideDuration: 3000
                    });
            })
            .catch((error) => {
                // Error during re-authentication (usually invalid password provided)
                if (error.code === 'auth/wrong-password') {
                    enqueueSnackbar(
                        intl.formatMessage({
                            id: 'app.profile.messages.changePassword.error.wrongCurrentPassword',
                            defaultMessage: 'You provided a wrong current password - please try again.'
                        }), {
                            variant: 'error',
                            preventDuplicate: true,
                            autoHideDuration: 5000
                        });
                } else {
                    enqueueSnackbar(
                        intl.formatMessage({
                            id: 'app.profile.messages.changePassword.error',
                            defaultMessage: 'Something went wrong while changing your password: {error}'
                        }, {error: error.message}), {
                            variant: 'error',
                            preventDuplicate: true,
                            autoHideDuration: 5000
                        });
                }
            })
    }

    const cancel = () => {
        history.push('/common/profile');
    }

    return {changePassword, cancel}
}
export default useChangePassword;